



































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from 'vuex-class';
@Component({
  components: {}
})
export default class MyGroupModal extends Vue {
  @Prop() show!: boolean;
  @Prop() myGroupList!: Array<Object>
  @Getter('mainTextColor') mainTextColor!: string;

  handleCloseModal() {
    this.$emit("hide");
  }
}
